import styles from './SearchCard.module.css'
import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const SearchCard = ({title,desc,url}) => {
  const navigate = useNavigate();

  const handleLinkClick = (link) => {
    navigate(link); 
    window.location.reload(); 
  };

  return (
    <div   className={styles.SearchCard} >
      <span className={styles.searchTitle} >{title}</span>
      <p className={styles.searchDesc}>{desc}</p>
      <Link onClick={() => handleLinkClick(url)} >
        <span className={styles.readmore} >READ MORE</span>
      </Link>
     
    </div>
  )
}

export default SearchCard
